import React from 'react'

export default props => {

	const size = props.small ? 28 : 34;

	return (
		<button
			type="button"
			className={`btn btn-${props.type}`}
			title={props.title}
			onClick={props.event}
			disabled={props.disabled}
			style={{
				visibility: props.visible ? 'visible' : 'hidden',

				width: props.width || size,
				height: props.height || size,

				marginLeft: props.marginLeft || 1,
				marginRight: props.marginRight || 1,
				marginTop: props.marginTop || 0,
				marginBottom: props.marginBottom || 0,

				padding: 0,

				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				verticalAlign: 'middle',
				flexShrink: 0,

				borderRadius: 8,
				border: 'none',

				boxShadow: props.disabled
					? 'none'
					: '0 2px 6px rgba(0, 0, 0, 0.15)',

				cursor: props.disabled
					? 'not-allowed'
					: 'pointer',

				transition: 'transform 0.18s ease, box-shadow 0.18s ease'
			}}
			onMouseEnter={event => {

				if (props.disabled) {
					return;
				}

				event.currentTarget.style.transform = 'translateY(-1px)';
				event.currentTarget.style.boxShadow =
					'0 4px 10px rgba(0, 0, 0, 0.22)';
			}}
			onMouseLeave={event => {

				event.currentTarget.style.transform = 'translateY(0)';
				event.currentTarget.style.boxShadow = props.disabled
					? 'none'
					: '0 2px 6px rgba(0, 0, 0, 0.15)';
			}}
		>
			<i
				className={props.icon}
				style={{
					fontSize: props.small ? 12 : 14,
					color: props.type === 'light'
						? props.color || '#495057'
						: props.color || '#ffffff',
					lineHeight: 1
				}}
			/>
		</button>
	);
}